import React, { useState } from 'react';
import './RecentCustomers.css';
import DateFilter from './DateFilter';
import config from '../config';

const RecentCustomers = ({ data, period, onPeriodChange }) => {
  const customerOptions = [
    { value: 'today', label: 'Today' },
    { value: 'last_week', label: 'Last Week' },
    { value: 'last_month', label: 'Last Month' },
    { value: 'all', label: 'All' }
  ];

  const [expanded, setExpanded] = useState({});
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState({});

  const handleExpand = async (company) => {
    setExpanded(prev => ({ ...prev, [company]: !prev[company] }));
    if (!details[company] && !loading[company]) {
      setLoading(prev => ({ ...prev, [company]: true }));
      try {
        console.log('Fetching details for company:', company);
        const url = `${config.API_BASE_URL}/company-details.php?company=${encodeURIComponent(company)}`;
        console.log('API URL:', url);
        const res = await fetch(url);
        const data = await res.json();
        console.log('API response:', data);
        console.log('Data length:', data.length);
        setDetails(prev => {
          const newDetails = { ...prev, [company]: data };
          console.log('Updated details state:', newDetails);
          return newDetails;
        });
      } catch (e) {
        console.error('Error fetching details:', e);
        setDetails(prev => ({ ...prev, [company]: [] }));
      } finally {
        setLoading(prev => ({ ...prev, [company]: false }));
      }
    }
  };

  if (!data || data.length === 0) {
    return (
      <div>
        <DateFilter
          value={period}
          onChange={onPeriodChange}
          options={customerOptions}
          label="Period:"
          showCustom={false}
        />
        <div className="no-data">No recent customer data available</div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatUsersList = (usersList) => {
    if (!usersList) return 'N/A';
    const users = usersList.split(', ');
    if (users.length <= 3) {
      return users.join(', ');
    }
    return `${users.slice(0, 3).join(', ')} +${users.length - 3} more`;
  };

  return (
    <div className="recent-customers">
      <DateFilter
        value={period}
        onChange={onPeriodChange}
        options={customerOptions}
        label="Period:"
        showCustom={false}
      />
      <div className="recent-table">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Company</th>
              <th>Access Count</th>
              <th>Unique Users</th>
              <th>Users List</th>
              <th>First Access</th>
              <th>Last Access</th>
            </tr>
          </thead>
          <tbody>
            {data.map((customer, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td>
                    <button className="expand-btn" onClick={() => handleExpand(customer.company)}>
                      {expanded[customer.company] ? '-' : '+'}
                    </button>
                  </td>
                  <td className="company-cell">
                    <span className="company-name">{customer.company || 'Unknown'}</span>
                  </td>
                  <td className="count-cell">
                    <span className="access-count">{(parseInt(customer.access_count) || 0).toLocaleString()}</span>
                  </td>
                  <td className="users-cell">
                    <span className="unique-users">{parseInt(customer.unique_users) || 0}</span>
                  </td>
                  <td className="users-list-cell">
                    <span className="users-list" title={customer.users_list}>
                      {formatUsersList(customer.users_list)}
                    </span>
                  </td>
                  <td className="first-access-cell">
                    <span className="first-access">{formatDate(customer.first_access)}</span>
                  </td>
                  <td className="last-access-cell">
                    <span className="last-access">{formatDate(customer.last_access)}</span>
                  </td>
                </tr>
                {expanded[customer.company] && (
                  <tr className="details-row">
                    <td colSpan={7}>
                      {console.log('Rendering details for:', customer.company, 'expanded:', expanded[customer.company], 'loading:', loading[customer.company], 'details:', details[customer.company])}
                      {loading[customer.company] && <div>Loading details...</div>}
                      {details[customer.company] && details[customer.company].length > 0 && (
                        <table className="details-table">
                          <thead>
                            <tr>
                              <th>User</th>
                              <th>Description</th>
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {details[customer.company].map((d, i) => (
                              <tr key={i}>
                                <td>{d.user}</td>
                                <td>{d.description}</td>
                                <td>{formatDate(d.dtstamp)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                      {details[customer.company] && details[customer.company].length === 0 && !loading[customer.company] && (
                        <div>No details found for this company.</div>
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <div className="recent-summary">
        <div className="summary-item">
          <span className="label">Total Companies:</span>
          <span className="value">{data.length}</span>
        </div>
        <div className="summary-item">
          <span className="label">Total Access:</span>
          <span className="value">
            {data.reduce((sum, customer) => sum + (parseInt(customer.access_count) || 0), 0).toLocaleString()}
          </span>
        </div>
        <div className="summary-item">
          <span className="label">Total Users:</span>
          <span className="value">
            {data.reduce((sum, customer) => sum + (parseInt(customer.unique_users) || 0), 0).toLocaleString()}
          </span>
        </div>
        <div className="summary-item">
          <span className="label">Avg Access/Company:</span>
          <span className="value">
            {Math.round(data.reduce((sum, customer) => sum + (parseInt(customer.access_count) || 0), 0) / data.length).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RecentCustomers; 